export const Field = ({ label, children, className = "" }) => (
  <label className={`block text-sm text-zinc-300 ${className}`}>
    <span className="mb-1 block">{label}</span>
    {children}
  </label>
);

export const Toggle = ({ label, checked, onChange, testId }) => (
  <label className="flex cursor-pointer items-center gap-3 text-sm text-zinc-200">
    <input type="checkbox" data-testid={testId} checked={checked} onChange={(e) => onChange(e.target.checked)} className="h-5 w-5 accent-[#FF5A1E]" />
    {label}
  </label>
);

export const numOrNull = (v) => (v === "" || v == null ? null : Number(v));
